module.exports = __webpack_public_path__ + "img/00009.308cd957.webp";